import type { MechanismContent } from '@/content/home';

export type WhatCloaklingDoesProps = {
  content: MechanismContent;
};

/**
 * "What Cloakling makes" mechanism section — 2-col layout with copy on the
 * left and a numbered 3-step proof card on the right. Pencil node WCM01.
 */
export function WhatCloaklingDoes({ content }: WhatCloaklingDoesProps) {
  return (
    <section
      aria-labelledby="mechanism-heading"
      className="border-b border-rule bg-canvas px-6 py-[96px] md:px-[72px]"
    >
      <div className="mx-auto flex max-w-[1296px] flex-col items-start justify-between gap-12 lg:flex-row lg:gap-20">
        <div className="flex w-full max-w-[560px] flex-col gap-5">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-pencil">
            {content.eyebrow}
          </p>
          <h2
            id="mechanism-heading"
            className="text-[34px] font-bold leading-[1.12] tracking-[-1px] text-ink md:text-[42px]"
          >
            {content.heading}
          </h2>
          <p className="text-[16px] leading-[1.58] text-graphite md:text-[17px]">{content.body}</p>
        </div>

        <div className="flex w-full flex-col gap-4 rounded-2xl border border-rule bg-page p-7 md:p-[34px] lg:max-w-[636px]">
          {content.steps.map((step) => (
            <div key={step.number} className="flex items-start gap-[18px]">
              <span
                aria-hidden="true"
                className="flex h-[34px] w-[34px] flex-shrink-0 items-center justify-center rounded-full bg-cloak-tint text-[14px] font-bold text-cloak-accent"
              >
                {step.number}
              </span>
              <div className="flex flex-col gap-1">
                <h3 className="text-[16px] font-bold text-ink">{step.title}</h3>
                <p className="text-[14px] leading-[1.5] text-graphite">{step.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
